/**
 * @module selectors/defaults
 */

/**
 * @typedef {module:utils/object~Object} Object
 * @typedef {HTMLElement|SVGElement} Root
 * @typedef {Object|{document:Document,root:Root,window:Window}} Defaults
 */

import object from '../utils/object.js'

const { document } = globalThis

/**
 * @type {Defaults}
 */
export default object(null, {
  document,
  root: document.documentElement,
  window: globalThis
})
